import { render, staticRenderFns } from "./RenderEvent.vue?vue&type=template&id=63dc427b"
import script from "./RenderEvent.vue?vue&type=script&lang=js"
export * from "./RenderEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports